<template>
  <!-- 文件列表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="12">
            <a-form-item label="图例名字">
              <a-input v-model="query.legendName" placeholder="请输入图例名字" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="图例编码">
              <a-input v-model="query.legendCode" placeholder="请输入图例编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="edit()" v-action:add>新增</a-button>
              <a-button
                type="danger"
                style="margin-left: 8px"
                @click="deleteSelectRow()"
                v-action:del
              >删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="edit(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="1100"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="log-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="图例名字">
          <a-input
            placeholder="图例名字"
            v-decorator="['legendName',{ rules: [{required: true, message: '请输入图例名字' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="图例编码">
          <a-input
            :disabled="this.isUpdate"
            placeholder="图例编码"
            v-decorator="['legendCode',{ rules: [{required: true,message: '请输入图例编码' }] }]"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input placeholder="备注" v-decorator="['remark']" />
        </a-form-item>
        <a-form-model-item
          :labelCol=" {
            xs: { span: 24 },
            sm: { span: 5 }
          }"
          :wrapperCol="{
            xs: { span: 24 },
            sm: { span: 19 }
          }"
          label="关联图表"
        >
          <a-button type="primary" @click="addLayer">添加</a-button>
          <a-table
            size="middle"
            rowKey="id"
            :data-source="layerList"
            :columns="layerColumns"
            :pagination="false"
            :scroll="{ y: 320 }"
          >
            <span slot="layerShowSort" slot-scope="text,record">
              <a-input-number v-model="record.layerShowSort" :min="99"></a-input-number>
            </span>
            <span slot="sort" slot-scope="text,record">
              <a-input-number v-model="record.sort" :min="1"></a-input-number>
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="deleteTable(record.id)">删除</a>
            </span>
          </a-table>
        </a-form-model-item>
      </a-form>
    </a-modal>
    <add-modal ref="addModal" @close="close"></add-modal>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import mixinViewModule from '@/mixin/common'
import AddModal from './module/legendAddModal'
const columns = [
  {
    title: '图例名字',
    dataIndex: 'legendName'
  },
  {
    title: '图例编码',
    dataIndex: 'legendCode'
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]
const layerColumns = [
  {
    title: '图层名字',
    dataIndex: 'layerName'
  },
  {
    title: '数据源',
    dataIndex: 'dataSource'
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  {
    title: '地图显示顺序',
    dataIndex: 'layerShowSort',
    scopedSlots: { customRender: 'layerShowSort' }
  },
  {
    title: '图例显示排序',
    dataIndex: 'sort',
    scopedSlots: { customRender: 'sort' }
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  components: {
    AddModal
  },
  mixins: [mixinViewModule],
  name: 'LogList',
  data() {
    return {
      pagination2: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      layerList: [],
      currentId: '',
      queryUrl: '/manager/base-legend/page',
      deleteUrl: '/manager/base-legend',
      addOrUpdateUrl: '/manager/base-legend',
      queryOneUrl: '/manager/base-legend',
      query: {
        legendName: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      layerColumns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },

  created() {},
  methods: {
    close(val) {
      if (!val || !Array.isArray(val) || val.length === 0) {
        return
      }
      var arr = []
      for (let item1 of val) {
        let flag = false
        item1.sort = 1
        if (this.layerList) {
          for (let item2 of this.layerList) {
            if (item1.id == item2.id) {
              flag = true
              item1.sort = parseInt(item2.sort)
            }
          }
        }

        if (flag) {
          arr.push(item1)
        } else {
          arr.unshift(item1)
        }
      }
      arr.sort((a, b) => {
        return a.sort - b.sort
      })
      this.layerList = arr
    },
    addLayer() {
      const arr = []
      const existingRows = []
      if (this.layerList && this.layerList.length > 0) {
        this.layerList.forEach(item => {
          arr.push(item.id)
          existingRows.push(item)
        })
      }
      this.$refs.addModal.show(arr, existingRows)
    },
    deleteTable(id) {
      const obj = this.layerList.find(item => {
        return item.id === id
      })
      const num = this.layerList.indexOf(obj)
      this.layerList.splice(num, 1)
      console.log(obj)
    },
    detailInfo(record) {
      this.detailForm = { ...record }
    },
    edit(id) {
      this.isUpdate = false
      this.layerList = []
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${id}`)
          .then(({ data }) => {
            this.addOrUpdateForm.setFieldsValue(pick(data, 'legendName', 'legendCode', 'remark'))
            this.layerList = data.layerList
          })
          .catch(() => {})
      }
    },
    handleOk(e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, {
            id: this.currentId,
            ...values,
            layerList: this.layerList
          })
            .then(res => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    handleCancel() {
      this.addOrUpdateForm.resetFields()
      this.layerList = []
      this.currentId = ''
      this.isUpdate = false
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
